import React from 'react';
import { map as mapCapped } from 'lodash/fp';
import { FormControl, FormControlLabel, Radio, RadioGroup} from '@mui/material';

const map = mapCapped.convert({ cap: false });

const UserListRadio =  ({users,selectedUser,onSelectUser})=>  {
  const selectionChange = (e) => onSelectUser(e.target.value);

  return (
    <FormControl>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="radio-buttons-group"
        value ={selectedUser}
        onChange={selectionChange}
      >
        {
          map((user, index) => <FormControlLabel
                key={index}
                value={user.Id}
                control={<Radio />}
                label={user.Name}
              />, users)
        }
      </RadioGroup>
  </FormControl>
  );
}
export { UserListRadio };

